import React from 'react';
import ReactHtmlParser from 'react-html-parser';

interface CommentProps {
  author: string;
  avatarUrl?: string;
  body: string;
  commentAuthorInitial?: string;
  commentCreated: string;
  commentableTitle: string;
  commentableUrl: string;
}

const Comment = ({
  author,
  avatarUrl,
  body,
  commentAuthorInitial,
  commentCreated,
  commentableTitle,
  commentableUrl,
}: CommentProps) => {
  return (
    <div className="comment-wrapper">
      <div className="comment-author-picture">
        {avatarUrl ? (
          <img src={avatarUrl} />
        ) : (
          <div className="avatar-placeholder">
            <div className="avatar-name">{commentAuthorInitial}</div>
          </div>
        )}
      </div>
      <div className="comment-container">
        <div className="comment-detail">
          <div className="article-title">
            <div className="comment-author-picture-mobile">
              {avatarUrl ? (
                <img src={avatarUrl} />
              ) : (
                <div className="avatar-placeholder">
                  <div className="avatar-name">{commentAuthorInitial}</div>
                </div>
              )}
            </div>
            <div className="article-detail">
              <div>
                <a href={commentableUrl}>{commentableTitle}</a>
              </div>
              <div className="commented-by">
                <span>Commented by: {author}</span>
              </div>
            </div>
          </div>
          <div className="comment-body">{ReactHtmlParser(body)}</div>
        </div>
        <div className="comment-actions">
          <div className="comment-actions-container">
            <div className="comment-date">{commentCreated}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Comment;
